function expandableActivities(element, $) {
    var $el = $(element);
    var itemsPerRow = $el.css('column-count');
    var activityItems = $el.find('.activityblock');
    var totalItems = activityItems.length;
    var itemHeight = activityItems.height();    
    var initRows = $el.data('rows');
    var totalRows = Math.ceil(parseFloat(totalItems) / parseFloat(itemsPerRow));    

    if(totalItems <= itemsPerRow) {
        return;
    }

    if(initRows > 0) {
        $el.height(itemHeight * initRows);
    }

    $el.next().children('a').on('click', function(e) {
        var newheight = $el.height() + itemHeight;
        $el.height(newheight);        
        if(parseInt(newheight) >= parseInt(totalRows * itemHeight)) {
            $(this).parent().hide();
        }
    });



}

$(function() {
    $(".expandable-activities").each(function(idx, item) {
        new expandableActivities(item, $);
    })

});